import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import DrawerHeader from './drawer-menu'

class DrawerHeaderPageLink extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('click', this.handlePageLinkClick)
    this.addEventListener('keyup', this.handleKeyDown)
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handlePageLinkClick)
    this.removeEventListener('keyup', this.handleKeyDown)
  }

  handlePageLinkClick = (event: MouseEvent): void => {
    event.preventDefault()

    this.setPage()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    event.preventDefault()

    const key = event.key || event.keyCode

    const isEnterKey = checkEnterKey(key)

    if (isEnterKey) {
      this.setPage()
    }
  }

  setPage(): void {
    const drawerHeader = this.closest<DrawerHeader>('drawer-menu')
    const pageId = this.dataset.pageId

    if (!pageId || !drawerHeader) {
      return
    }

    const page = drawerHeader.getPage(pageId)

    if (!page) {
      return
    }

    drawerHeader.setPage(page)
  }
}

export default DrawerHeaderPageLink
